import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

import Login from "@/pages/flashcards/Login";
import ForgotPassword from "@/pages/flashcards/ForgotPassword";
import ResetPassword from "@/pages/flashcards/ResetPassword";

import Dashboard from "@/pages/student/Dashboard";
import Study from "@/pages/student/Study";
import Courses from "@/pages/student/Courses";
import Progress from "@/pages/student/Progress";
import Account from "@/pages/student/Account";
import Guide from "@/pages/student/Guide";

import AdminOverview from "@/pages/admin/Overview";
import AdminStudents from "@/pages/admin/Students";
import AdminCourses from "@/pages/admin/Courses";
import AdminFlashcards from "@/pages/admin/Flashcards";
import AdminImports from "@/pages/admin/Imports";
import AdminAnalytics from "@/pages/admin/Analytics";
import AdminSettings from "@/pages/admin/Settings";

import { Protected } from "@/components/Protected";
import { StudentLayout } from "@/components/StudentLayout";
import { AdminLayout } from "@/components/AdminLayout";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />

          <Route path="/flashcards" element={<Login />} />
          <Route path="/flashcards/forgot-password" element={<ForgotPassword />} />
          <Route path="/flashcards/reset-password" element={<ResetPassword />} />

          <Route path="/flashcards/guide" element={<Protected><Guide /></Protected>} />

          <Route
            element={
              <Protected role="student">
                <StudentLayout />
              </Protected>
            }
          >
            <Route path="/flashcards/dashboard" element={<Dashboard />} />
            <Route path="/flashcards/study" element={<Study />} />
            <Route path="/flashcards/courses" element={<Courses />} />
            <Route path="/flashcards/progress" element={<Progress />} />
            <Route path="/flashcards/account" element={<Account />} />
          </Route>

          <Route
            element={
              <Protected role="admin">
                <AdminLayout />
              </Protected>
            }
          >
            <Route path="/flashcards/admin" element={<AdminOverview />} />
            <Route path="/flashcards/admin/students" element={<AdminStudents />} />
            <Route path="/flashcards/admin/courses" element={<AdminCourses />} />
            <Route path="/flashcards/admin/flashcards" element={<AdminFlashcards />} />
            <Route path="/flashcards/admin/imports" element={<AdminImports />} />
            <Route path="/flashcards/admin/analytics" element={<AdminAnalytics />} />
            <Route path="/flashcards/admin/settings" element={<AdminSettings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
